import { render, staticRenderFns } from "./MenuButtonList.vue?vue&type=template&id=3faafdc6&scoped=true"
import script from "./MenuButtonList.vue?vue&type=script&lang=js"
export * from "./MenuButtonList.vue?vue&type=script&lang=js"
import style0 from "./MenuButtonList.vue?vue&type=style&index=0&id=3faafdc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faafdc6",
  null
  
)

export default component.exports